import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title"> Blogs </h1>
          <div className="text fsz-18 color-666">
            Latest thoughs, Ideas & Plan. <br /> Writing is socially acceptable
            form of schizophrenia
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
